import { Injectable } from '@angular/core';
import {
	CreateVehicleColorDto,
	UpdateVehicleColorDto,
	VehicleColorListDto,
	VehicleColorRecordDto,
	VehicleColorsAppOptionsDto,
	VehicleColorSearchDto,
	VehicleColorsFilters,
	VehicleColorsStatsDto,
	ModulesEnum,
} from '@splitsecondconnect/ultramarine-shared';

import { BaseService } from '../../../../../../../shared/base-classes/base.service';

@Injectable({
	providedIn: 'root',
})
export class VehicleColorService extends BaseService<
	VehicleColorRecordDto,
	CreateVehicleColorDto,
	UpdateVehicleColorDto,
	VehicleColorListDto,
	VehicleColorsStatsDto,
	VehicleColorsAppOptionsDto,
	VehicleColorsFilters,
	VehicleColorSearchDto
> {
	constructor() {
		super();
		this.relativeUrl = ModulesEnum.VEHICLE_COLORS;
		this._newRecord = undefined;
	}
}
